import { Component, OnInit, ViewEncapsulation, Inject } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Customer } from "../../shared/interface/customer";
import { CustomerService } from "../../shared/services/customer/customer.service";
import { RoleService } from "../../shared/services/role/role.service";
import { Observable } from "rxjs/Observable";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  FormArray
} from "@angular/forms";

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class UsersComponent implements OnInit {
  customers: Customer[];

  constructor(
    public dialog: MatDialog,
    private customerService: CustomerService
  ) { }

  ngOnInit() {
    this.customers = [];
    this.setList();
    this.customerService.getAction().subscribe(data => {
      if (["create", "update"].includes(data.action)) {
        this.setList();
      }
    });
  }

  setList() {
    this.customerService.list().subscribe(res => {
      this.customers = res;
    });
  }

  delete(customerId) {
    if (
      confirm(
        "Are you sure you want to remove this user"
      ) == false
    ) {
      return false;
    }

    let temp = this.customers;
    this.customers = this.customers.filter(item => item["_id"] !== customerId);
    this.customerService.delete(customerId).subscribe(
      r => { },
      e => {
        this.customers = temp;
      }
    );
  }

  openUserDialog = (data: any = {}) => {
    this.dialog.open(UserDialog, {
      data: data,
      height: "auto",
      width: "400px",
      panelClass: "full-modal"
    });
  };
}

@Component({
  selector: "user-dialog",
  templateUrl: "user.dialog.html"
})
export class UserDialog {
  roleList$: Observable<any>;
  customerForm: FormGroup;
  isSubmitted: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private roleService: RoleService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UserDialog>,
    private customerService: CustomerService
  ) {
    this.roleList$ = this.roleService.list("fields=roleName");
    this.data = this.parseData(this.data);
    this.createForm(data);
  }

  createForm(data: any) {
    this.customerForm = this.fb.group({
      customerId: data._id,
      name: [data.name, Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z\' ]+$')])],
      email: [data.email, Validators.compose([Validators.required, Validators.email])],
      mobile: [data.mobile, Validators.compose([Validators.pattern('^[0-9]+$')])],
      address: data.address,
      roleId: [data.roleId, Validators.required],
      isActive: data.isActive
    });
  }

  parseData(data: any) {
    if (data && data._id && data._id != "") {
      data.roleId = data.role.roleId;
      return data;
    }

    data = {
      _id: "",
      name: "",
      email: "",
      mobile: "",
      address: "",
      roleId: "",
      isActive: ""
    }

    return data
  }

  onSubmit(form: any) {
    if (!this.customerForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    if (form.isActive == true) {
      form.isActive = 1;
    } else {
      form.isActive = 0;
    }

    if (!form.customerId) {
      this.customerService.create(form).subscribe(res => {
        this.customerService.sendAction("create", "");
        this.dialogRef.close();
        this.isSubmitted = 0;
      }, err => {
        this.isSubmitted = 0;
      });
    } else {
      this.customerService.update(form).subscribe(res => {
        this.customerService.sendAction("update", "");
        this.dialogRef.close();
        this.isSubmitted = 0;
      }, err => {
        this.isSubmitted = 0;
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/users/users.component.ts